import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

// import app from './modules/app'
// import settings from './modules/settings'
// import user from './modules/user'
// import permission from './modules/permission'
// import tagsView from './modules/tagsView'
// import SelectArea from './modules/SelectArea';

Vue.use(Vuex)

// --> 自动化导入modules文件

// 匹配modules文件夹所有.js后缀的文件
const modulesFiles = require.context('./modules', true, /\.js$/)

// 遍历刚刚匹配的模块文件函数全部key
// modulesFiles:Function
// .keys() 是modulesFiles的方法 用于获取这个函数匹配到的名字
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const store = new Vuex.Store({
  // modules: {
  //   app,
  //   settings,
  //   user,
  //   permission,
  //   tagsView,
  //   SelectArea
  // },
  modules,
  getters
})

export default store
